export const OutlookTaskContent = ({ resource }) => {
  return false
}
